module.exports = __webpack_public_path__ + "img/bracelet.f70870ed.png";